const DELETE_ROLE = [
  'owner',
  'admin'
]

const EXPORT_ROLE = [
  'owner',
  'admin',
  'brandManager',
  'delegationManager'
]

export {
  DELETE_ROLE, EXPORT_ROLE
}